













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ name: 'ams-pagination' })
export default class AMSTooltip extends Vue {
  @Prop({ type: String }) content!: string;
  @Prop({ type: Number }) oWidth!: number;
  @Prop({ type: String }) diableColor!: string;
}
